define("checkout/components/seamless-checkout/review-changes-button", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if @isVisible}}
    <div>
      <Shared::Ui::Button
        @additional="block"
        @isDisabled={{this.isDisabled}}
        @onClick={{action @onClickAction}}
        @size="large"
        @text={{t "plans.checkout.review_changes.button"}}
        @variant="outline"
        class="u--m__tb__sm tCH--btn--secondary qa--review_changes_btn"
        data-test-id="review-changes-btn"
      />
  
      {{#if this.isDisabled}}
        <EmberTooltip @event="hover" data-test-id="review-changes-tooltip">
          {{this.tooltip}}
        </EmberTooltip>
      {{/if}}
    </div>
  {{/if}}
  */
  {
    "id": "TndtmQXP",
    "block": "[[[41,[30,1],[[[1,\"  \"],[10,0],[12],[1,\"\\n    \"],[8,[39,1],[[24,0,\"u--m__tb__sm tCH--btn--secondary qa--review_changes_btn\"],[24,\"data-test-id\",\"review-changes-btn\"]],[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"isDisabled\"]],[28,[37,2],[[30,0],[30,2]],null],\"large\",[28,[37,3],[\"plans.checkout.review_changes.button\"],null],\"outline\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"isDisabled\"]],[[[1,\"      \"],[8,[39,4],[[24,\"data-test-id\",\"review-changes-tooltip\"]],[[\"@event\"],[\"hover\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[30,0,[\"tooltip\"]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"@isVisible\",\"@onClickAction\"],false,[\"if\",\"shared/ui/button\",\"action\",\"t\",\"ember-tooltip\"]]",
    "moduleName": "checkout/components/seamless-checkout/review-changes-button.hbs",
    "isStrictMode": false
  });
  let ReviewChangesButtonComponent = _exports.default = (_class = class ReviewChangesButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
    }
    get isDisabled() {
      return !this.args.hasUpcomingPlanChanges && !this.args.hasChanges || !this.args.hasCompleteAddress || this.args.handleChangePlanRunning;
    }
    get tooltip() {
      if (!this.args.hasCompleteAddress) {
        return this.intl.t('errors.address.invalid_line');
      }
      return this.intl.t('plans.checkout.charges.none');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ReviewChangesButtonComponent);
});